<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ChevronRightIcon } from '@heroicons/vue/20/solid';

const route = useRoute();
const router = useRouter();

const props = defineProps({
    items: {
        type: Array,
        default: () => []
    },
    itemRight: {
        type: Object,
        default: () => {}
    }
});

const current = computed(() => {
    const current: any[] = [];
    props.items.forEach((item: any) => {
        if (item?.to.includes(route.path.slice(0, 6))) current.push(item);
    });
    return current[0];
});

const breadcrumbs = computed(() => {
    const breadcrumbs: string[] = [];
    if (route.path.split('/')[2]) {
        route.path.split('/').forEach((name, i) => {
            if (i >= 2) breadcrumbs.push(name);
        });
        return breadcrumbs;
    }
    return [];
});

const breadcrumbComplement = (breadcrumb: string) => {
    if (breadcrumb === 'add') return 'Mailboxes';
    else if (breadcrumb === 'business') return 'Hours';
    else if (breadcrumb === 'metric') return 'Adjustments';
    else if (breadcrumb === 'contact-groups') return 'Groups';
    return '';
};

const handleRoute = (isLastOne: boolean) => {
    if (isLastOne) return route.path;
    return router.back();
};
</script>

<template>
    <header class="h-12 bg-white border-b border-gray-200 px-5 py-2.5 flex items-center justify-between">
        <div v-if="current" class="flex items-center">
            <component :is="current.icon" class="w-4 h-4 mr-1.5 text-gray-600"></component>
            <router-link class="text-sm font-medium mr-1" :to="current.to" :class="breadcrumbs.length ? 'text-gray-600 hover:text-gray-950' : 'text-gray-950'">{{ current.text }}</router-link>
            <div v-for="(breadcrumb, i) of breadcrumbs" :key="i" class="flex gap-1 items-center">
                <ChevronRightIcon class="w-4 h-4 text-gray-600" />
                <component
                    :is="'button'"
                    class="text-sm font-medium mr-1 cursor-pointer"
                    :class="i + 1 < breadcrumbs.length ? 'text-gray-600 hover:text-gray-950' : 'text-gray-950'"
                    @click="handleRoute(i + 1 === breadcrumbs.length)"
                    >{{ breadcrumb.charAt(0).toUpperCase() }}{{ breadcrumb.slice(1).split('-')[0] }} {{ breadcrumbComplement(breadcrumb) }}</component
                >
            </div>
        </div>
        <component :is="itemRight.typeComponent" class="flex gap-1.5 px-2 py-1 cursor-pointer items-center rounded-lg hover:bg-gray-100" @click="itemRight.handlerClick">
            <span class="text-gray-950 text-sm font-semibold leading-tight">{{ itemRight.text }}</span>
            <component :is="itemRight.icon" class="w-4 h-4 text-gray-500"></component>
        </component>
    </header>
</template>
